import { useRouter } from 'next/router';

import { Link } from '@playbooks/ui/components/link';

const BlogSubnav = () => {
	const router = useRouter();

	// Methods
	const isActive = pathName => {
		const paths = router.asPath.split('?')[0].split('/');
		const path = paths[paths.length - 1];
		return path === pathName;
	};

	// Render
	return (
		<nav aria-label='Blog categories' className='min-w-0 overflow-x-auto custom-scrollbar'>
			<span className='flex-start gap-1'>
				<Link
					variant='tab'
					size='xs'
					aria-label='all'
					data-active={isActive('')}
					href='/'
					className='shrink-0 font-normal'>
					All
				</Link>
				<Link variant='tab' size='xs' data-active={isActive('news')} href='/news' className='shrink-0 font-normal'>
					News
				</Link>
				<Link
					variant='tab'
					size='xs'
					data-active={isActive('changelog')}
					href='/changelog'
					className='shrink-0 font-normal'>
					Changelog
				</Link>
				<Link
					variant='tab'
					size='xs'
					data-active={isActive('perspectives')}
					href='/perspectives'
					className='shrink-0 font-normal'>
					Perspectives
				</Link>
				<Link
					variant='tab'
					size='xs'
					data-active={isActive('engineering')}
					href='/engineering'
					className='shrink-0 font-normal'>
					Engineering
				</Link>
				<Link
					variant='tab'
					size='xs'
					data-active={isActive('customers')}
					href='/customers'
					className='shrink-0 font-normal'>
					Customers
				</Link>
			</span>
		</nav>
	);
};

export { BlogSubnav };
